import { useStonlyWidget, usePylonWidget, useQuarterzipSdk } from 'lib/scripts';
/**
 * ScriptLoader component that loads external scripts only when user is authenticated
 * This component uses the useUser hook internally through the script loading hooks
 */
export function ScriptLoader() {
  // Load external scripts - hooks will automatically check for user authentication
  // useGoogleMaps();
  useStonlyWidget();
  usePylonWidget();
  useQuarterzipSdk();

  // This component doesn't render anything visible
  return null;
}
